import React, {PureComponent} from "react"

import Query, {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import {CompanyNewsTile, QueryCompanyNewsArgs, LayoutWidgets, QueryLayoutWidgetsArgs} from "@irati/types"
import getTenantHomePageQuery from "../../queries/TenantHomePage"

type TenantHomePageArguments = QueryCompanyNewsArgs & QueryLayoutWidgetsArgs

interface Props
  extends Omit<QueryComponentProps<{companyNews: CompanyNewsTile[]; layoutWidgets: LayoutWidgets}, TenantHomePageArguments>, "query"> {}

export default class TenantHomePageQuery extends PureComponent<Props> {
  render() {
    return <Query {...this.props} query={getTenantHomePageQuery} />
  }
}
